import React, { PureComponent } from 'react';

import { Router, Route, Switch, Redirect } from 'react-router-dom';

import Error from 'containers/Error/Error.container';
import Dashboard from 'containers/Dashboard/Dashboard.container';
import route from '.';
import history from '../shared/utils/History';

export default class NavProvider extends PureComponent {
  render() {
    return (
      <Router history={history}>
        <div className="main-container">
          <Switch>
            <Route exact path={route.ERROR} component={Error} />
            <Route exact path="/" component={Dashboard} />
            <Route path={route.DASHBOARD} component={Dashboard} />
            <Redirect to={route.DASHBOARD} />
          </Switch>
        </div>
      </Router>
    );
  }
}
